import axios from "axios";
import { geoServerBaseUrl } from "./baseUrl";

export const getProjects = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const headers = { accesstoken: localStorage.jwtTokenMapid };
      const url = `${geoServerBaseUrl}/projects/get_list_new?limit=15&skip=0`;
      const response = await axios.get(url, { headers });
      resolve(response.data);
    } catch (error) {
      reject(error);
    }
  });
};

export const searchProjects = (query) => {
  return new Promise(async (resolve, reject) => {
    try {
      const headers = { accesstoken: localStorage.jwtTokenMapid };
      const url = `${geoServerBaseUrl}/layers_new/search_projects/${query}`;
      const response = await axios.get(url, { headers });
      resolve(response.data);
    } catch (error) {
      reject(error)
    }
  });
}